export function hotDataLoad(e, func) {
	const scrollBottom = e.target.scrollTop + e.target.offsetHeight === e.target.scrollHeight;
	if (scrollBottom) {
		func();
	}
}
